import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import AuthorizedTenantElement from "@/common/components/Auth/AuthorizedTenantElement";
import { ViewVariant } from "@/common/ts/layout";
import { EntityType, VehicleDto } from "@/core/api/generated/v1";

import GeneralStatusHistoryPaginatedList from "../../../GeneralStatus/GeneralStatusHistory/ListView/GeneralStatusHistoryPaginatedList";

interface Props {
  vehicle: VehicleDto;
}

export default function GeneralStatusHistoryTabContent({ vehicle }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <AuthorizedTenantElement
          tenantIdsAny={[vehicle?.tenantId, vehicle?.ownerTenantId]}
          withAlert
        >
          <GeneralStatusHistoryPaginatedList
            defaultValues={{
              subjectEntityType: EntityType.Vehicle,
              subjectEntityId: vehicle.id,
            }}
            displayProps={{
              viewVariant: ViewVariant.Tab,
              isForSubjectEntity: true,
              title: true,
            }}
          />
        </AuthorizedTenantElement>
      </ViewContentBlock>
    </PageTabContent>
  );
}
